<template>
  <draggable @end="moveHandler" ref="container" tag="table" :disabled="!draggable" draggable=".body-group" :animation="200" handle=".body-handle" style="width: 100%; position: relative; border-spacing: 0 .15em" class="table" >
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <slot v-else />
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  props: {
    list: Array,
    headers: {
      type: Array,
      default: () => []
    },
    loading: Boolean,
    no_data_text: {
      type: String,
      default: 'No data'
    },
    search: {
      type: Function,
      default(){return true}
    },
    draggable: Boolean
  },
  methods: {
    moveHandler(evt) {
      console.log(evt.oldDraggableIndex, evt.newDraggableIndex)
      if (evt.oldDraggableIndex == evt.newDraggableIndex) return
      this.$emit('dragged', {
        from: evt.oldDraggableIndex,
        to: evt.newDraggableIndex
      })
    },
    expandAll(){
      this.$refs.container.$children.forEach(el => 'expand' in el ? el.expand() : '');
    },
    foldAll(){
      this.$refs.container.$children.forEach(el => 'fold' in el ? el.fold() : '');
    }
  },
  components: {
    draggable
  }
}
</script>

<style>
.table {
	width: 100%;
  margin: 0;
  column-gap: 0;
  border-spacing: 0px;
}
.table thead th {
	/* font-weight: bold; */
	text-align: left;
	border: none;
	padding: .4rem .4rem;
	color: var(--v-secondary-base);
	font-size: .8rem;
  z-index: 10000;
}

.table thead {
  background: var(--v-secondary-lighten5);
  box-shadow: 0px 5px 12px -10px var(--v-secondary-base);
  overflow: hidden;
}

.table tr {
  transition: all .1s ease-in-out;
  border-bottom: 1px solid var(--v-secondary-base);
}

/* .table thead tr th:first-child {
	border-radius: 8px 0 0 8px;
}
.table thead tr th:last-child {
	border-radius: 0 8px 8px 0;
} */

.table tbody td {
	text-align: left;
	border: none;
	padding: .4rem .4rem;
	font-size: .9rem;
	vertical-align: center;
}
.table tbody tr:nth-child(even){
	background: #f4f4f4;
}
/* .table tbody tr td:first-child {
	border-radius: 8px 0 0 8px;
}
.table tbody tr td:last-child {
	border-radius: 0 8px 8px 0;
} */

.table tbody tr:hover {
  background: var(--v-secondary-lighten4) !important;
  cursor: pointer;
}

.sortable-ghost {
  opacity: 0;
}
</style>